var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "nav nav-mobile-menu" }, [
      _c("li", { staticClass: "nav-item" }, [
        _c("a", { staticClass: "nav-link", attrs: { href: "#/profile" } }, [
          _c("i", { staticClass: "nc-icon nc-single-02" }),
          _vm._v(" Profile\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "nav-item" }, [
        _c("a", { staticClass: "nav-link", attrs: { href: "#/logout" } }, [
          _c("i", { staticClass: "nc-icon nc-button-power" }),
          _vm._v(" Log out\n    ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e3fc914", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e3fc914","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Layout/Extra/MobileMenu.vue
// module id = fmYR
// module chunks = 4